import axios from "axios"
export function getScreenData(token, page, pageSize) {
    return axios.get(process.env.REACT_APP_API_URL + `/getScreenData?page=${page}&pageSize=${pageSize}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}